import { Info } from "lucide-react";
import { IconBtn, Tooltip } from "@/design-system/components/ui";

/**
 * D6 / J7 — a card's help paragraph behind an ⓘ beside its title, word for
 * word. The app's one `Tooltip` shows it on hover and on keyboard focus; the
 * button's accessible name carries the same words, so a screen reader reads
 * the paragraph without the visual bubble (the Tooltip contract). The text is
 * not otherwise on the page.
 */
export function InfoHint({ text, testId }: { text: string; testId?: string }) {
  return (
    <Tooltip label={text}>
      <IconBtn
        label={text}
        className="h-6 w-6 border-0 rounded-pill text-gray-mid"
        data-testid={testId}
      >
        <Info size={14} strokeWidth={1.75} aria-hidden />
      </IconBtn>
    </Tooltip>
  );
}
